import { render, staticRenderFns } from "./AssignOrderToCarrierModal.vue?vue&type=template&id=a2b44b68&scoped=true&"
import script from "./AssignOrderToCarrierModal.vue?vue&type=script&lang=js&"
export * from "./AssignOrderToCarrierModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignOrderToCarrierModal.vue?vue&type=style&index=0&id=a2b44b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b44b68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2b44b68')) {
      api.createRecord('a2b44b68', component.options)
    } else {
      api.reload('a2b44b68', component.options)
    }
    module.hot.accept("./AssignOrderToCarrierModal.vue?vue&type=template&id=a2b44b68&scoped=true&", function () {
      api.rerender('a2b44b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/AssignOrderToCarrierModal.vue"
export default component.exports